import Constants from "../services/Constants";

const initialStateSave = {
  showModal: {
    DROPOFF: false,
    PICKUP: false
  },
};

export function assignJourneySafe(state = initialStateSave, action) {
  switch(action.type) {
    case 'ASSIGN_JOURNEY_SAFE.SUCCESS': {
      return {
        ...state
      };
    }
    case 'HIDE_ASSIGN_SAFE_MODAL':
      return {
        ...state,
        showModal: {DROPOFF: false, PICKUP: false}
      };
    case 'SHOW_ASSIGN_SAFE_MODAL':
      const isDropOff = action.safeType === Constants.DROPOFF_247;
      return {
        ...state,
        showModal: {DROPOFF: isDropOff, PICKUP: !isDropOff}
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/safe.js